export const REQUEST_NKN_CATEGORY = 'REQUEST_NKN_CATEGORY';
export const RECEIVE_NKN_CATEGORY = 'RECEIVE_NKN_CATEGORY';

export const REQUEST_NKN_CATEGORIES = 'REQUEST_NKN_CATEGORIES';
export const RECEIVE_NKN_CATEGORIES = 'RECEIVE_NKN_CATEGORIES';
